import angular from 'angular';
import moment from 'moment';
import gridHeight from '../core/shared-service/grid-utils';

class containersListCtrl {
    /* @ngInject */
    constructor(
        uiGridConstants,
        uiGridExporterConstants,
        $translate,
        ContainerService,
        PrincipalSvc,
        LadProviderService,
        CompanyService,
        AuthSvc,
        logger,
        LANGUAGES,
        $uibModal,
        ContainersFilter,
        $state,
        toastr
    ) {
        this.uiGridConstants = uiGridConstants;
        this.uiGridExporterConstants = uiGridExporterConstants;
        this.$translate = $translate;
        this.ContainerService = ContainerService;
        this.PrincipalSvc = PrincipalSvc;
        this.LadProviderService = LadProviderService;
        this.CompanyService = CompanyService;
        this.AuthSvc = AuthSvc;
        this.logger = logger;
        this.LANGUAGES = LANGUAGES;
        this.$uibModal = $uibModal;
        this.ContainersFilter = ContainersFilter;
        this.$state = $state;
        this.toastr = toastr;
    }

    $onInit() {
        this.languages = this.LANGUAGES;
        this.ladProviders = this.LadProviderService.findAll();

        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="app.principal.consult.updatecontainer({ id : row.entity.principalId, mode: \'details\', containerId: row.entity.containerId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer" >{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        var translatedCellTemplate =
            '<a class="grid-cell-link" ui-sref="app.principal.consult.updatecontainer({ id : row.entity.principalId, mode: \'details\', containerId: row.entity.containerId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer" >{{COL_FIELD | translate}}</div></a>';
        var containerModeCellTemplate =
            '<a class="grid-cell-link" ui-sref="app.principal.consult.updatecontainer({ id : row.entity.principalId, mode: \'details\', containerId: row.entity.containerId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{"container_mode." + COL_FIELD | translate}}</div></a>';

        this.gridOptions = {
            columnDefs: [
                {
                    name: 'companyId',
                    displayName: 'principal.container.column.company.id',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    type: 'number',
                    sort: { direction: this.uiGridConstants.ASC, priority: 1 },
                },
                {
                    name: 'companyName',
                    displayName: 'principal.container.column.company.name',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'perimeterCode',
                    displayName: 'principal.containers.perimeter',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    sort: { direction: this.uiGridConstants.ASC, priority: 2 },
                },
                {
                    name: 'containerId',
                    displayName: 'principal.container.column.container.id',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    sort: { direction: this.uiGridConstants.ASC, priority: 3 },
                    type: 'number',
                },
                {
                    name: 'containerMode',
                    displayName: 'dashboard.column.envelope.application',
                    cellTemplate: containerModeCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'containerType',
                    displayName: 'principal.container.column.container.type',
                    cellTemplate: translatedCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'dematMode',
                    displayName: 'principal.container.column.container.dematMode',
                    cellTemplate: translatedCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'mappingFilename',
                    displayName: 'principal.container.column.container.treatment',
                    cellTemplate: translatedCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'containerName',
                    displayName: 'principal.container.column.container.name',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'ladProviderName',
                    displayName: 'principal.container.column.ladProviderName',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'containerStatus',
                    displayName: 'principal.container.column.container.status',
                    cellTemplate: translatedCellTemplate,
                    headerCellFilter: 'translate',
                },
            ],
            enableGridMenu: false,
            enableRowSelection: true,
            enableSelectAll: true,
            selectionRowHeaderWidth: 30,
            enableColumnMenus: false,
            onRegisterApi: gridApi => {
                this.gridApi = gridApi;
            },
            exporterOlderExcelCompatibility: true,
        };
        this.clearForm();
    }
    searchContainers() {
        this.cleanContainersFormParam();
        this.containerPromise = this.ContainerService.searchByCriterias(this.criteria).$promise;
        this.containerPromise.then(
            data => {
                this.gridOptions.data = data;
                this.updateTreatmentColumn();
            },
            () => {
                this.logger.error('error.search');
            }
        );
    }

    clearForm() {
        this.initCriterias();
        this.searchContainers();
    }

    initCriterias() {
        this.criteria = new this.ContainersFilter();
        var pcpId = Number(this.PrincipalSvc.getPrincipalId());
        if (!isNaN(pcpId)) {
            this.criteria.principalId = pcpId;
        }
    }

    /**
     * Ouvre la popup de désactivation des containers.
     */
    openDisableModal() {
        this.$uibModal
            .open({
                component: 'modalContainerDisable',
                resolve: {
                    containersSelected: () => {
                        return this.getContainersIdsSelected();
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(() => {
                return this.closeContainerDisableModal(this.getContainersIdsSelected());
            }, this.dismissModal);
    }

    closeContainerDisableModal(containersSelected) {
        if (containersSelected) {
            const containersFiltered = this.getContainersSelectedWithoutUpload();
            this.ContainerService.disableContainers(containersFiltered).$promise.then(
                () => {
                    this.logger.success('Les containers ont été mis à jour');
                    this.searchContainers();
                },
                () => {
                    this.logger.error('error.update');
                }
            );
        }
    }

    /**
     * Fournit les containers sélectionnés non UPLOAD.
     */
    getContainersSelectedWithoutUpload() {
        var result = [];
        if (this.gridApi.selection) {
            var selectedRows = this.gridApi.selection.getSelectedRows();
            for (var i = 0; i < selectedRows.length; i++) {
                if (!(selectedRows[i].containerType === 'UPLOAD' && selectedRows[i].containerMode === 'KISS')) {
                    result.push(selectedRows[i].containerId);
                }
            }
        }
        return result;
    }

    openUpdateModal() {
        this.$uibModal
            .open({
                component: 'modalContainerUpdate',
                resolve: {
                    containersSelected: () => {
                        return this.getSelectedContainers();
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(this.searchContainers, this.dismissModal);
    }

    openEnableModal() {
        this.$uibModal
            .open({
                component: 'modalContainerEnable',
                resolve: {
                    containersSelected: () => {
                        return this.getContainersIdsSelected();
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                () => this.searchContainers(),
                () => this.dismissModal()
            );
    }

    dismissModal() {}

    getNameIdentifier(val) {
        return this.CompanyService.autocompleteNameId({
            principalId: this.PrincipalSvc.getPrincipalId(),
            data: val,
        }).$promise.then(result => {
            return result;
        });
    }

    cleanContainersFormParam() {
        if (this.criteria.containerType === '') {
            this.criteria.containerType = undefined;
        }
        if (this.criteria.containerMode === '') {
            this.criteria.containerMode = undefined;
        }
        if (this.criteria.dematMode === '') {
            this.criteria.dematMode = undefined;
        }
        if (this.criteria.containerStatus === '') {
            this.criteria.containerStatus = undefined;
        }
        if (this.criteria.traitementType === '') {
            this.criteria.traitementType = undefined;
        }
    }

    isContainerSelected() {
        if (!(this.gridApi === undefined || this.gridApi.selection === undefined)) {
            return this.gridApi.selection.getSelectedRows().length > 0;
        }
        return false;
    }

    /**
     * Retourne les identifiants des containers sélectionnés.
     */
    getContainersIdsSelected() {
        var ids = [];
        if (this.gridApi.selection) {
            var selectedRows = this.gridApi.selection.getSelectedRows();
            for (var i = 0; i < selectedRows.length; i++) {
                ids.push(selectedRows[i].containerId);
            }
        }
        return ids;
    }

    getSelectedContainers() {
        const selected = [];
        if (this.gridApi.selection) {
            const selectedRows = this.gridApi.selection.getSelectedRows();
            for (var i = 0; i < selectedRows.length; i++) {
                selected.push({ id: selectedRows[i].containerId, mode: selectedRows[i].containerMode });
            }
        }
        return selected;
    }

    /** Mise à jour de la colonne traitement avec le nom du fichier de mapping si le traitement est spécifique. */
    updateTreatmentColumn() {
        var gridData = this.gridOptions.data;
        if (gridData.length === 0) {
            return;
        }
        // Construit un nom fictif de nom de fichier de mapping pour les mappings génériques
        var genMappings = { P: 'Générique PASREL', G: 'Générique GIS' };
        for (var i = 0; i < gridData.length; i++) {
            if (!gridData[i].mappingFilename) {
                gridData[i].mappingFilename = genMappings[gridData[i].dematPlatformId];
            }
        }
    }

    exportCsv() {
        this.gridOptions.exporterCsvFilename = 'principal-containers_' + moment().format('DDMMYYYY') + '.csv';
        this.gridOptions.exporterHeaderFilter = this.$translate.instant;
        this.gridOptions.exporterFieldCallback = (grid, row, col, value) => {
            if (['containerType', 'dematMode', 'mappingFilename', 'containerStatus'].indexOf(col.name) != -1) {
                value = this.$translate.instant(value);
            }
            return value;
        };
        this.gridApi.exporter.csvExport(this.uiGridExporterConstants.ALL, this.uiGridExporterConstants.ALL);
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }

    /**
     * Ouvre la popup de la suppression des containers.
     */
    openDeleteModal() {
        this.$uibModal
            .open({
                component: 'modalContainerDelete',
                size: 'lg',
                resolve: {
                    containersSelected: () => {
                        return this.getContainersIdsSelected();
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                () => this.searchContainers(),
                () => this.dismissModal()
            );
    }

    /**
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight(gridApi) {
        return gridHeight(gridApi);
    }

    backList() {
        this.$state.go('do', { tabName: 'principal' });
    }
}

angular.module('app.principal').component('containersList', {
    templateUrl: require('./containers-list.html'),
    controller: containersListCtrl,
    bindings: {},
});
